<inline-skjema>
  <form [formGroup]="skjema" (ngSubmit)="lagre()" class="e2e-nyesakerskjema" #skjemaelement>
    @for (kontroller of skjema.controls.saker.controls; track indeks; let indeks = $index; let erSisteRad = $last) {
      <inline-skjema-blokk class="nysak-kontainer">
        @if(erSisteRad){<mat-icon fontSet="ion-ios-plus-outline" class="mat-icon--ionic-ikon nysak-markør" (click)="giFokusTilNySakFelt()"/>}
        <sak-ny [skjema]="kontroller" [moete]="moete()" [tilleggsdata]="tilleggsdata" (vedSlett)="slettSak(indeks)" [(viserDetaljer)]="viserDetaljer" [forrigeSakDag]="forrigeSakDag(indeks)"/>
      </inline-skjema-blokk>
    }

    @if (viserFulltSkjema()){
    <inline-skjema-handlinger navigasjonforhindret-flash>
      <button mat-raised-button type="submit" color="primary" cdkFocusInitial [visSpinner]="lagrer()" [disabled]="lagrer() || skjema.invalid" spinnerTekst="{{'Oppretter...'|translate}}">
        {{ "Opprett {antall} saker"|translate:{antall:antallSaker()} }}
      </button>
      <button mat-stroked-button type="button" (click)="avbryt()">
        {{ "Avbryt"|translate }}
      </button>
      <div class="avstand"></div>
      <div class="sortering">
        <mat-slide-toggle [formControl]="skjema.controls.sorterEtterSakstype" [matTooltip]="sorterEtterSakstypeTips">
          {{'Sorter saker etter sakstype'|translate}}
        </mat-slide-toggle>
        @if(initiellSorterEtterSakstypeEndret()){
          <mat-checkbox [formControl]="skjema.controls.huskSorterEtterSakstypeValg" matTooltip="{{'Bruk dette som standard på møter i denne gruppen'|translate}}">
            {{'Husk dette valget' | translate}}
          </mat-checkbox>
        }
      </div>
      <mat-slide-toggle [formControl]="skjema.controls.informerSaksansvarlig" matTooltip="{{'Sender epost til saksansvarlige med varsel om at de har fått ansvar for sak'|translate}}">
        {{'Informer om sakstildeling'|translate}}
      </mat-slide-toggle>
    </inline-skjema-handlinger>
    }
  </form>
</inline-skjema>

@if (viserNySakTips()) {
  <tips class="første-sak-tips">
    {{'Legg til saker i møtet ved å skrive saksnavnet i feltet "Tittel på ny sak"'|translate}}
  </tips>
}

@if(viserFulltSkjema()){
<tips noekkel="nyesaker" stil="stor" class="generelle-tips">
  <ol>
    <li [innerHTML]="'<span class=tips__lenke>Aktiver visning av detaljer</span> for å se alle saksfeltene.'|translate" (click)="viserDetaljer.set(true)"></li>
    <li [innerHTML]="'Merk alle saker med <span class=tips__fokusord>sakstype</span> (orientering, beslutning, diskusjon,m.fl.). Sakstype tydeliggjør forventet utfall av saken (mål og hensikt). Sakstype kommuniserer betydningen av gruppemedlemmenes forberedelse og hvilken type engasjement som forventes under behandling av saken i møtet.'|translate"></li>
    <li [innerHTML]="'Styreplan hjelper deg å holde tiden dersom du setter <span class=tips__fokusord>varighet</span> på sakene.'|translate"></li>
    <li [innerHTML]="'Plasser ansvar ved å sette <span class=tips__fokusord>ansvarlig</span> på saken, vedkommende vil få melding om at han eller hun er tildelt ansvar for saken.'|translate"></li>
  </ol>
</tips>
}
